export enum SlotID {
  PrimaryButtons = 'PrimaryButtonsSlot',
  PrimaryPanels = 'PrimaryPanelsSlot',
  TopBarSecondaryActions = 'TopBarSecondaryActions',
  HelpMenuItems = 'HelpMenuItemsSlot',
  StickyPanel = 'StickyPanel',
  StageLayer = 'StageLayer',
  ToolsMenuItem = 'ToolsMenuItem',
}
